
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

// types
import { FtlTariffById } from '@/core/types/billing.types'

// realisations
import { billing } from '@/core/realisations/billing.realisation'

// composable
import { useRoute } from 'vue-router'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        Loader,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            tariffs: null as FtlTariffById[] | null,
        })

        const route = useRoute()
        const company_id = Number(route.params.id)

        const loadFtlTariff = async () => {
            try {
                state.is_loading = true
                state.is_failed = false

                const response = await billing.getFtlTariffsByCompanyId(company_id)
                state.tariffs = response.data
            } catch (error) {
                console.log(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
                state.is_failed = false
            }
        }

        const getCompanyName = computed(() => {
            if (!state.tariffs || !state.tariffs[0]) return ''

            let result = `(${state.tariffs[0].companyName})`
            if (state.tariffs[0].vatEnabled) result += ' - НДС включен'
            else result += ' - НДС выключен'
            return result
        })

        const isVatEnabled = computed(
            () => state.tariffs && state.tariffs[0] && state.tariffs[0].vatEnabled
        )
        const isVatDisabled = computed(
            () => state.tariffs && state.tariffs[0] && !state.tariffs[0].vatEnabled
        )

        onBeforeMount(loadFtlTariff)

        return {
            state,
            loadFtlTariff,
            getCompanyName,
            isVatEnabled,
            isVatDisabled,
        }
    },
})
